import { IComponentOptions } from "angular";
import { ContractInstanceFieldsComponentController } from "./controller";

export const vsComponentName = "contractInstanceFields";

export const contractInstanceFieldsComponentOptions: IComponentOptions = {
  controller: ContractInstanceFieldsComponentController,
  controllerAs: "fieldsController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
  },
};
